import { Permission } from 'shared'
import { useGlobalState } from 'context/GlobalStateContext'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { Role, useRolesTableContext } from '../../../../RolesTableContext'
import {
  CreateRoleModalBody,
  CreateRoleModalValues,
} from './components/CreateRoleModalBody'
import { useCreateRoleMutation } from 'schema'
import { errorHandler } from 'hooks/errorHandler'

export function useCreateOptions(): CreateHeaderActionOptions<Role> {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const { refetch, fetching } = useRolesTableContext()
  const [createRole] = useCreateRoleMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createRole: {
        role: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    loading: fetching,
    entity: 'Role',
    permission: Permission.CreateRole,
    modal: {
      type: 'simple',
      body: <CreateRoleModalBody />,
      onOk: async ({ name, permissionIds }: CreateRoleModalValues) => {
        if (!projectId) {
          return errorHandler('Project id must be defined')
        }

        await createRole({
          variables: { createRoleInput: { projectId, name, permissionIds } },
        })
        await refetch()
      },
    },
  }
}
